/* eslint-disable react/destructuring-assignment */
import { Table } from 'antd'
import React from 'react'
import moment from 'moment'

import { AllowedModule, Plan } from 'types'
import { useAppSelector } from 'hooks/reduxHooks'
import addCurrencySymbol from 'utils/addCurrencySymbol'

/**
 * ClientsTable component props
 */

interface PropTypes {
	planHis: Plan[] | []
	loading: boolean
}

const PlanHistoryTable: React.FC<PropTypes> = ({ planHis, loading }) => {
	const currency =
		useAppSelector(
			state => state.singleClient.clientProfile?.currency_selected
		) || 'INR'

	/**
	 * Data for Singlr client
	 */
	const clientColumns = [
		{
			title: 'Name',
			dataIndex: 'planName',
			render(text: string) {
				return {
					props: {
						style: { wordBreak: 'break-word' },
					},
					children: <div>{text}</div>,
				}
			},
		},
		{
			title: 'Type',
			dataIndex: 'planType',
		},
		{
			title: 'Billing Cycle',
			dataIndex: 'billingCycle',
		},
		{
			title: 'Per Month',
			dataIndex: 'perMonth',
			render: (perMonth: number) =>
				perMonth ? addCurrencySymbol(perMonth, currency) : '--',
		},
		{
			title: 'Per Year',
			dataIndex: 'perYear',
			render: (perYear: number) =>
				perYear ? addCurrencySymbol(perYear, currency) : '--',
		},
		{
			title: 'Modules',
			dataIndex: 'allowedModules',
			render: (allowedModules: AllowedModule[] | null | undefined) => (
				<Table
					dataSource={allowedModules || []}
					pagination={false}
					columns={[
						{
							title: 'Type',
							dataIndex: 'type',
						},
						{
							title: 'Count',
							dataIndex: 'count',
						},
					]}
				/>
			),
		},
		{
			title: 'Visible',
			dataIndex: 'visible',
			render: (visible: any[]) => (visible ? 'Yes' : 'No'),
		},
		{
			title: 'Created At',
			dataIndex: 'createdAt',
			render: (createdAt: Date) => moment(createdAt).format('DD-MM-YYYY'),
			width: 110,
		},
	]
	return (
		<Table
			columns={clientColumns}
			rowKey={plan => plan._id}
			dataSource={planHis}
			loading={loading}
			pagination={false}
			scroll={{ x: 'calc(100vw - 36.34rem)' }}
		/>
	)
}

export default PlanHistoryTable
